"use client"

import { Group, Anchor, Text } from "@forestsync/ui"
import Link from "next/link"

export function Footer() {
  return (
    <Group justify="space-between" wrap="wrap" gap="xs" px="md" py="sm">
      <Text size="xs" c="dimmed">
        © {new Date().getFullYear()} ForestWatch AS · Trading as ForestSync. All rights reserved.
      </Text>
      <Group gap="md">
        <Anchor component={Link} href="/terms" size="xs" c="dimmed">
          Terms of Service
        </Anchor>
        <Anchor href="https://forestsync.com/privacy" target="_blank" rel="noopener noreferrer" size="xs" c="dimmed">
          Privacy Policy
        </Anchor>
        <Anchor component={Link} href="/legal/mfa" size="xs" c="dimmed">
          MFA v1.0
        </Anchor>
      </Group>
    </Group>
  )
}
